import React, { useState } from 'react';
import { Link } from '@mui/material';
import { postDataAPI } from '../../../Helpers/FetchAPI';
import { logger } from '../../../utils/logger';
import CircularProgress from '@mui/material/CircularProgress';
import backgroundImg from '../../../images/background.png';
import { formatDate } from '../../../utils/formatters';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';

export default function Certification({ user, workbook }) {
  const [isLoading, setIsLoading] = useState(false);
  const completionDate = new Date();

  const certNewWindow = async () => {
    setIsLoading(true);
    postDataAPI(
      '/userWorkbookItems/generateCert',
      {
        user: user,
        workbook: workbook
      },
      { responseType: 'arraybuffer' }
    )
      .then((response) => response.data)
      .then((response) => {
        const uint8arr = new Uint8Array(response);

        const link = document.createElement('a');
        const blob = new Blob([uint8arr], { type: 'application/pdf' });

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', 'Certificate.pdf');

        document.body.appendChild(link);

        link.click();
        link.remove();
      })
      .catch((err) => {
        logger.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className='w-full'>
      <div
        className='width-full m-auto max-w-125.5 md:max-w-200 aspect-square bg-cover bg-no-repeat relative'
        style={{ backgroundImage: `url(${backgroundImg})` }}
      >
        <div className='text-center relative top-[45%] left-0.5 md:pt-4'>
          <p className='font-extrabold text-pdteal text-[7px] md:text-sm lg:text-xl m-0 h-auto'>PRESENTED TO</p>
          <p className='font-extrabold text-pddarkblue my-0 md:mb-8 md:text-3xl lg:text-4xl'>{user.firstName} {user.lastName}</p>
          <p className='font-extrabold text-pdteal text-[7px] md:text-sm lg:text-xl m-0 h-auto'>FOR THE COMPLETION OF THE COURSE:</p>
          <p className='font-extrabold text-pddarkblue my-0 md:mb-8 text-sm md:text-xl lg:text-2xl lg:py-1'>"{workbook.title}"</p>
          <p className='font-extrabold text-pdteal text-[7px] md:text-sm lg:text-xl m-0 h-auto'>ON</p>
          <p className='font-extrabold text-pddarkblue my-0 md:mb-8 text-sm md:text-xl lg:text-2xl lg:py-1'>{formatDate(completionDate)}</p>
        </div>
      </div>
      <div className='flex justify-center w-full h-full md:h-auto items-center mt-12 2xl:mb-6'>
        <Link className='inline-flex items-center justify-between rounded-lg bg-pddarkblue px-6 py-3 cursor-pointer gap-x-3' onClick={certNewWindow} target='_blank'>
          <span className='text-xl font-semibold text-white'>Download Certificate</span>
          {isLoading ? (
            <CircularProgress
              className='size-6 mt-0.5 text-white'
            />
          ) : (
            <ArrowDownTrayIcon className='size-6 stroke-white' />
          )}
        </Link>
      </div>
    </div>
  );
}